import axios from 'axios';

/**
 * 資料フォルダ一覧取得
 */
export const getFileFolders = (construct_id: number) => {
  return axios
    .get(`/api/v1/file-folders?construct_id=${construct_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 資料詳細取得
 */
export const getFileDetailsById = (id: number) => {
  return axios
    .get(`/api/v1/file/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getDocumentStatusDocument = (
  constructId: number,
  identificationId: string,
  fileId: number
) => {
  return axios
    .get(
      `/api/v1/e-contract/get-document-status/document?construct_id=${constructId}&identification_id=${identificationId}&file_id=${fileId}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 資料更新
 */
export const editFileDetailById = (
  id: any,
  name: string,
  construct_id: number,
  file_folder_id: number,
  file_type_id: number,
  file_type_name: string,
  amount: number,
  send_to: number,
  send_to_name: string,
  receive_from: number,
  receive_from_name: string,
  exchange_date: string,
  file_name: string,
  description: string
) => {
  return axios
    .put(
      `api/v1/update/file/${id}`,
      {
        name,
        construct_id,
        file_folder_id,
        file_type_id,
        file_type_name,
        amount,
        send_to,
        send_to_name,
        receive_from,
        receive_from_name,
        exchange_date,
        file_name,
        description
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 資料フォルダ名更新
 */
export const editFileFolderById = (folder_id: any, name: string) => {
  return axios
    .post(
      `api/v1/update-folder/files/${folder_id}`,
      {
        folder_id,
        name
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * GMOサイン電子契約封筒用文書登録
 */
export const registGmoDocument = (
  document: string,
  fileId: number,
  constructId: number
) => {
  return axios
    .post(
      `api/v1/e-contract/gmo-regist-document`,
      {
        document,
        file_id: fileId,
        construct_id: constructId
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 契約大臣電子契約封筒用文書登録
 */
export interface Contractor {
  order_no: number;
  sign_type: number;
  name: string;
  email1: string;
  is_send_mail: number;
  contractors: {
    document_code: string;
    request_type: string;
  }[];
}

export const registDaijinDocument = (
  constructId: number,
  constructName: string,
  fileDetailName: string,
  eContractSendToName: string,
  eContractSendToMail: string,
  eSignatureFileId: number,
  groupId: string,
  size: number
) => {
  return axios
    .post(
      `api/v1/e-contract/daijin-regist-document`,
      {
        construct_id: constructId,
        construct_name: constructName,
        fileDetail_name: fileDetailName,
        e_contract_send_to_name: eContractSendToName,
        e_contract_send_to_mail: eContractSendToMail,
        e_signature_fileId: eSignatureFileId,
        group_id: groupId,
        size: size
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * GMOサイン署名依頼
 */
type Document = {
  document_code: string;
  document_name: string;
};

export interface PartnerSigner {
  order_no: number;
  sign_type: number;
  name: string;
  email: string;
  is_send_mail: number;
  document_list: {
    document_code: string;
    request_type: string;
  }[];
}
export const sendSignGmoRequest = (
  construct_id: number,
  file_id: string,
  construct_name: string,
  document_list: Document[],
  partner_signer_list: PartnerSigner[],
  e_contract_send_to_name?: string,
  e_contract_send_to_mail?: string
) => {
  const requestData = {
    construct_id,
    construct_name,
    e_contract_send_to_name,
    e_contract_send_to_mail,
    document_list: document_list.map(doc => ({
      document_code: doc.document_code,
      document_name: doc.document_name
    })),
    partner_signer_list: partner_signer_list.map(signer => ({
      order_no: signer.order_no,
      sign_type: signer.sign_type,
      name: signer.name,
      email: signer.email,
      is_send_mail: signer.is_send_mail,
      document_list: signer.document_list.map(doc => ({
        document_code: doc.document_code,
        request_type: doc.request_type
      }))
    }))
  };
  return axios
    .post(`api/v1/e-contract/send-gmo-sign-request/${file_id}`, requestData, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 契約大臣署名依頼
 */
export const sendSignDaijinRequest = (
  file_id: number,
  identificationId: string,
  constructId: number
) => {
  return axios
    .post(
      `api/v1/e-contract/send-sign-daijin-request/${file_id}`,
      {
        identification_id: identificationId,
        construct_id: constructId
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * グループ取得（大臣）
 */
export const getDaijinGroupList = (fileId: number, constructId: number) => {
  return axios
    .get(
      `/api/v1/e-contract/get-daijin-groups?file_id=${fileId}&construct_id=${constructId}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * GMOサイン契約書PDF取得
 */
export const getGmoContractPdf = (
  identificationId: string,
  fileId: number,
  constructId: number
) => {
  return axios
    .post(
      `api/v1/e-contract/download-gmo-contract-pdf/${identificationId}?file_id=${fileId}&construct_id=${constructId}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(response => {
      return response.data;
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (err.response.data.error === 'Missing cookie access_token_cookie') {
          return 'Not logged in!';
        } else {
          return err.response.data;
        }
      } else {
        return err.response;
      }
    });
};

/**
 * GMOサイン契約締結証明書取得
 */
export const getGmoCertificationPdf = (
  identificationId: string,
  fileId: number,
  constructId: number
) => {
  return axios
    .get(
      `api/v1/e-contract/download-gmo-certification-pdf/${identificationId}?file_id=${fileId}&construct_id=${constructId}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(response => {
      return response.data;
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (err.response.data.error === 'Missing cookie access_token_cookie') {
          return 'Not logged in!';
        } else {
          return err.response.data;
        }
      } else {
        return err.response;
      }
    });
};

/**
 * 契約大臣契約書PDF取得
 */
export const getDaijinContractPdf = (
  identificationId: string,
  fileId: number,
  constructId: number
) => {
  return axios
    .get(
      `api/v1/e-contract/download-daijin-contract-pdf/${identificationId}?file_id=${fileId}&construct_id=${constructId}`,
      {
        headers: {
          withCredentials: true
        },
        responseType: 'blob'
      }
    )
    .then(response => {
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      return pdfUrl;
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (err.response.data.error === 'Missing cookie access_token_cookie') {
          return 'Not logged in!';
        } else {
          return err.response.data;
        }
      } else {
        return err.response;
      }
    });
};

/**
 * 契約大臣合意締結証明書取得
 */
export const getDaijinCertificationPdf = (
  identificationId: string,
  fileId: number,
  constructId: number
) => {
  return axios
    .get(
      `api/v1/e-contract/download-daijin-certification-pdf/${identificationId}?file_id=${fileId}&construct_id=${constructId}`,
      {
        headers: {
          withCredentials: true
        },
        responseType: 'blob'
      }
    )
    .then(response => {
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      return pdfUrl;
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (err.response.data.error === 'Missing cookie access_token_cookie') {
          return 'Not logged in!';
        } else {
          return err.response.data;
        }
      } else {
        return err.response;
      }
    });
};

/**
 * 契約大臣電子契約文書情報取得
 */
export const getDaijinDetailInfo = (
  identificationId: string,
  fileId: number,
  constructId: number
) => {
  return axios
    .get(
      `api/v1/e-contract/daijin-detail-data/${identificationId}?file_id=${fileId}&construct_id=${constructId}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 資料フォルダ閲覧権限変更
 */
export const updateFolderAuthority = (
  folderId: number,
  outsidePartnerId: number[]
) => {
  return axios
    .post(
      `/api/v1/update-folder/files/authorities/${folderId}`,
      {
        outside_partner_ids: outsidePartnerId
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(res => {
      return res.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 資料フォルダの閲覧権限がある社外パートナーのIDを取得
 */
export const getAuthorizedOutsidePartner = (folderId: number) => {
  return axios
    .get(
      `/api/v1/get-folder/files/authorized_outside_partner_ids/${folderId}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(res => {
      return res.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
